import es from './es';
import en from './en';

export default { Espanol: es, es_419: es, English: en, en_us: en };
